import imagesLoaded from 'imagesloaded';

import { debounce } from '../../../common/utils';

import els from './elements';
import heading from './heading';
import timeline from './timeline';

let context = null;

let preparing = false;

const prepare = () => {

    if (preparing) {
        return;
    }

    preparing = true;

    context = gsap.context(() => {

        heading.prepare();
        timeline.prepare();
    });

    preparing = false;
};

const cleanUp = () => {

    context?.revert();

    heading.cleanUp();

    timeline.cleanUp();
};

const initialize = () => {

    imagesLoaded(
        els.$section(),
        () => {

            prepare();
            timeline.prepareInitialScrollAnimation();
            timeline.registerEventListeners();

            $(window).on(
                'resize:horizontally',
                debounce(
                    () => {
                        cleanUp();
                        prepare();
                    },
                    50
                )
            );
        }
    );
};

export default {
    initialize,
};

